package com.eladfinish.bible.contest.ui.scaffold

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Snackbar
import androidx.compose.material3.SnackbarData
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.ui.text.BasicTextWithInlineClicks

private const val CLICK_TAG = "CLICK"
private val SNACKBAR_MAX_HEIGHT = 260.dp

@Composable
fun AppSnackbar(
    snackbarData: SnackbarData,
    modifier: Modifier = Modifier,
    textStyle: TextStyle = MaterialTheme.typography.bodyLarge.copy(fontSize = 18.sp),
) {
    val visuals = snackbarData.visuals as? AppSnackbarVisuals
    val richText = visuals?.richText
    val clicks = visuals?.richClicksById.orEmpty()

    Snackbar(
        modifier = modifier
            .heightIn(max = SNACKBAR_MAX_HEIGHT),
        action = {
            snackbarData.visuals.actionLabel?.let { label ->
                TextButton(onClick = { snackbarData.performAction() }) {
                    Text(text = label)
                }
            }
        },
    ) {
        if (richText != null) {
            BasicTextWithInlineClicks(
                modifier = Modifier.fillMaxWidth(),
                text = richText,
                style = textStyle.copy(textAlign = TextAlign.Start),
                onClickOffset = { offset ->
                    val id = richText.getStringAnnotations(
                        tag = CLICK_TAG,
                        start = offset,
                        end = offset,
                    ).firstOrNull()?.item

                    if (id != null) clicks[id]?.invoke()
                }
            )
        } else {
            Text(
                modifier = Modifier.fillMaxWidth(),
                text = snackbarData.visuals.message,
                style = textStyle.copy(textAlign = TextAlign.Start),
            )
        }
    }
}
